import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { useEffect }  from 'react';
import BuyBeltInit from '../shims/buy-belt-init';
import BuyBeltLoading from './buy-belt-loading';
import BuyBelt from './buy-belt';

// try{
//   if(window && window.$){
//     window.$('#buybelt-wrapper').show();
//   }
// }catch(e){
//   console.error(e);
// }

function BuyBeltContainer({
  pipModel={},
  pipHooks=null,
  loading=false,
  error=false,
  //remove these after pip merge
  finishInit,
}) {
  const partialReload = window.DETECTED_PIP_PARTIAL_RELOAD || false;

  if(window && window.location && window.location.search.indexOf("debug=true")>-1){console.log("\n==================================\nBuyBeltContainer() props=", pipModel, JSON.stringify(pipModel));}

  if(error){
    return (
      <BuyBeltLoading error={true} />
    );
  }else if(loading){
    return (
      <BuyBeltLoading />
    );
  }else{
    BuyBeltInit.setPipHooks(pipHooks, pipModel, finishInit);

    if(BuyBeltInit.shouldDisplayLegacyScenario()){
      return null;
    }else{
      return (
        <BuyBelt
          pipModel={pipModel}
          partialReload={partialReload}
        />
      );
    }
  }

}

window.BuyBeltNew = BuyBeltContainer;
window.BuyBeltNewInit = BuyBeltInit.init;

export default BuyBeltContainer;
